import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  fetchPdfDocument,
  getOrganizationDocuments,
  organizationAwards,
  organizationDocumentBulkDelete,
  organizationDocumentCheck,
  organizationDocumentIsActive,
  organizationUploadDocuments,
} from "../../../api/organization_api";

export const getOrganizationDocumentAction = createAsyncThunk(
  "organizationDocuments/getOrganizationDocuments",
  async (params, { rejectWithValue, getState }) => {
    try {
      const organizationDocuments = await getOrganizationDocuments(params);
      return organizationDocuments; // The controller now returns { data, totalCount, page, pageSize }
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const getUserOrganizationDocumentAction = createAsyncThunk(
  "organizationDocuments/getUserOrganizationDocumentAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const organizationDocuments = await getOrganizationDocuments();
      let data =
        organizationDocuments.data?.filter(
          (item) =>
            item?.organisationID === values.organisationName &&
            item.isActive === true
        ) || [];
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);
export const organizationAwardsAction = createAsyncThunk(
  "organizationDocuments/organizationAwardsAction",
  async (params, { rejectWithValue, getState }) => {
    try {
      const organizationDocuments = await organizationAwards(params);

      return organizationDocuments;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const organizationDocumentUploadAction = createAsyncThunk(
  "organizationDocuments/organizationDocumentUploadAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const organizationDocuments = await organizationUploadDocuments(values);
      return organizationDocuments;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const organizationDocumentIsActiveAction = createAsyncThunk(
  "organizationDocuments/organizationDocumentIsActiveAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const organizationDocuments = await organizationDocumentIsActive(values);
      return organizationDocuments;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const organizationDocumentCheckAction = createAsyncThunk(
  "organizationDocuments/organizationDocumentCheckAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const organizationDocuments = await organizationDocumentCheck(values);
      return organizationDocuments;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const organizationDocumentBulkDeleteAction = createAsyncThunk(
  "organizationDocuments/organizationDocumentBulkDeleteAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const organizationDocuments =
        await organizationDocumentBulkDelete(values);
      return organizationDocuments;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const fetchPdfDocumentAction = createAsyncThunk(
  "organizationDocuments/fetchPdfDocument",
  async (pdfUrl, { rejectWithValue }) => {
    try {
      const pdfData = await fetchPdfDocument(pdfUrl);

      return pdfData;
    } catch (error) {
      return rejectWithValue({
        error: error.message || "Error fetching the PDF document",
      });
    }
  }
);
